module.exports = __webpack_public_path__ + "static/media/newsletter-june-2018-hike.32eca534.jpg";